import { iGameSaved, iGameTemplate, iHouseState } from "../context/interfaces";
import { isPlayable } from "../rules";
interface response {
  houseStates: iHouseState[][],
  maxScore: number,
}

export default function initializeHousesStates(template: iGameTemplate, saved: iGameSaved): response {
  let houseStates: iHouseState[][] = [];
  let maxScore = 0;
  //initialize the house state based on the template
  for (let i = 0; i < template.matrix.length; i++) {
    houseStates[i] = [];
    for (let j = 0; j < template.matrix[i].length; j++) {
      const playable = isPlayable(template.matrix[i][j]);
      if (playable) {
        maxScore++
      }
      // pontuada = jogável, não revelada e com a letra certa (case-insensitive)
      const mine = saved.cache?.matrix?.[i]?.[j];
      const scored = playable
        && !mine?.revelada
        && !!mine?.letra
        && mine.letra.toUpperCase() === (template.matrix[i][j].letra ?? '').toUpperCase();
      houseStates[i][j] = {
        isSubFocused: false,
        isCorrect: '',
        isFocused: false,
        scored: scored,
        isHighlight: template.matrix[i][j].destaque,
        palavraHorizontal: template.matrix[i][j].palavra_horizontal,
        palavraVertical: template.matrix[i][j].palavra_vertical,
      };
    }
  }

  return { houseStates, maxScore };
}
